/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 * The version of the OpenAPI document: 4.22.9
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base';
// @ts-ignore
import { Bool } from '../model';
// @ts-ignore
import { HallEmplacementRead } from '../model';
// @ts-ignore
import { HallEmplacementWrite } from '../model';
// @ts-ignore
import { HallEmplacementsGetCollection200Response } from '../model';
// @ts-ignore
import { HallPeriodPricingRead } from '../model';
// @ts-ignore
import { HallPeriodPricingWrite } from '../model';
// @ts-ignore
import { HallPeriodPricingsGetCollection200Response } from '../model';
// @ts-ignore
import { HallRead } from '../model';
// @ts-ignore
import { HallWrite } from '../model';
// @ts-ignore
import { HallsGetCollection200Response } from '../model';
// @ts-ignore
import { Time } from '../model';
/**
 * HallApi - axios parameter creator
 * @export
 */
export const HallApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of HallEmplacement resources.
     * @summary Retrieve hall emplacements
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [hall]
     * @param {Array<string>} [hall2]
     * @param {string} [emplacement]
     * @param {Array<string>} [emplacement2]
     * @param {string} [hallLocation]
     * @param {Array<string>} [hallLocation2]
     * @param {string} [paxBetween]
     * @param {string} [paxGt]
     * @param {string} [paxGte]
     * @param {string} [paxLt]
     * @param {string} [paxLte]
     * @param {string} [hallSquareMetersBetween]
     * @param {string} [hallSquareMetersGt]
     * @param {string} [hallSquareMetersGte]
     * @param {string} [hallSquareMetersLt]
     * @param {string} [hallSquareMetersLte]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsGetCollection: async (
      page?: number,
      itemsPerPage?: number,
      hall?: string,
      hall2?: Array<string>,
      emplacement?: string,
      emplacement2?: Array<string>,
      hallLocation?: string,
      hallLocation2?: Array<string>,
      paxBetween?: string,
      paxGt?: string,
      paxGte?: string,
      paxLt?: string,
      paxLte?: string,
      hallSquareMetersBetween?: string,
      hallSquareMetersGt?: string,
      hallSquareMetersGte?: string,
      hallSquareMetersLt?: string,
      hallSquareMetersLte?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/hall_emplacements`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter['itemsPerPage'] = itemsPerPage;
      }

      if (hall !== undefined) {
        localVarQueryParameter['hall'] = hall;
      }

      if (hall2) {
        localVarQueryParameter['hall[]'] = hall2;
      }

      if (emplacement !== undefined) {
        localVarQueryParameter['emplacement'] = emplacement;
      }

      if (emplacement2) {
        localVarQueryParameter['emplacement[]'] = emplacement2;
      }

      if (hallLocation !== undefined) {
        localVarQueryParameter['hall.location'] = hallLocation;
      }

      if (hallLocation2) {
        localVarQueryParameter['hall.location[]'] = hallLocation2;
      }

      if (paxBetween !== undefined) {
        localVarQueryParameter['pax[between]'] = paxBetween;
      }

      if (paxGt !== undefined) {
        localVarQueryParameter['pax[gt]'] = paxGt;
      }

      if (paxGte !== undefined) {
        localVarQueryParameter['pax[gte]'] = paxGte;
      }

      if (paxLt !== undefined) {
        localVarQueryParameter['pax[lt]'] = paxLt;
      }

      if (paxLte !== undefined) {
        localVarQueryParameter['pax[lte]'] = paxLte;
      }

      if (hallSquareMetersBetween !== undefined) {
        localVarQueryParameter['hall.squareMeters[between]'] =
          hallSquareMetersBetween;
      }

      if (hallSquareMetersGt !== undefined) {
        localVarQueryParameter['hall.squareMeters[gt]'] = hallSquareMetersGt;
      }

      if (hallSquareMetersGte !== undefined) {
        localVarQueryParameter['hall.squareMeters[gte]'] = hallSquareMetersGte;
      }

      if (hallSquareMetersLt !== undefined) {
        localVarQueryParameter['hall.squareMeters[lt]'] = hallSquareMetersLt;
      }

      if (hallSquareMetersLte !== undefined) {
        localVarQueryParameter['hall.squareMeters[lte]'] = hallSquareMetersLte;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a HallEmplacement resource.
     * @summary Retrieve a single hall emplacement
     * @param {string} id HallEmplacement identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsIdGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallEmplacementsIdGet', 'id', id);
      const localVarPath = `/api/hall_emplacements/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates the HallEmplacement resource.
     * @summary Update an existing hall emplacement
     * @param {string} id HallEmplacement identifier
     * @param {HallEmplacementWrite} hallEmplacementWrite The updated HallEmplacement resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsIdPatch: async (
      id: string,
      hallEmplacementWrite: HallEmplacementWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallEmplacementsIdPatch', 'id', id);
      // verify required parameter 'hallEmplacementWrite' is not null or undefined
      assertParamExists(
        'hallEmplacementsIdPatch',
        'hallEmplacementWrite',
        hallEmplacementWrite,
      );
      const localVarPath = `/api/hall_emplacements/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hallEmplacementWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the HallEmplacement resource.
     * @summary Replace an existing hall emplacement
     * @param {string} id HallEmplacement identifier
     * @param {HallEmplacementWrite} hallEmplacementWrite The updated HallEmplacement resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsIdPut: async (
      id: string,
      hallEmplacementWrite: HallEmplacementWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallEmplacementsIdPut', 'id', id);
      // verify required parameter 'hallEmplacementWrite' is not null or undefined
      assertParamExists(
        'hallEmplacementsIdPut',
        'hallEmplacementWrite',
        hallEmplacementWrite,
      );
      const localVarPath = `/api/hall_emplacements/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hallEmplacementWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of HallPeriodPricing resources.
     * @summary Retrieve hall period pricing
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [hall]
     * @param {Array<string>} [hall2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsGetCollection: async (
      page?: number,
      itemsPerPage?: number,
      hall?: string,
      hall2?: Array<string>,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/hall_period_pricings`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter['itemsPerPage'] = itemsPerPage;
      }

      if (hall !== undefined) {
        localVarQueryParameter['hall'] = hall;
      }

      if (hall2) {
        localVarQueryParameter['hall[]'] = hall2;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a HallPeriodPricing resource.
     * @summary Retrieve a single hall period pricing
     * @param {string} id HallPeriodPricing identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsIdGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallPeriodPricingsIdGet', 'id', id);
      const localVarPath = `/api/hall_period_pricings/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates the HallPeriodPricing resource.
     * @summary Update an existing hall period pricing
     * @param {string} id HallPeriodPricing identifier
     * @param {HallPeriodPricingWrite} hallPeriodPricingWrite The updated HallPeriodPricing resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsIdPatch: async (
      id: string,
      hallPeriodPricingWrite: HallPeriodPricingWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallPeriodPricingsIdPatch', 'id', id);
      // verify required parameter 'hallPeriodPricingWrite' is not null or undefined
      assertParamExists(
        'hallPeriodPricingsIdPatch',
        'hallPeriodPricingWrite',
        hallPeriodPricingWrite,
      );
      const localVarPath = `/api/hall_period_pricings/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hallPeriodPricingWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the HallPeriodPricing resource.
     * @summary Replace an existing hall period pricing
     * @param {string} id HallPeriodPricing identifier
     * @param {HallPeriodPricingWrite} hallPeriodPricingWrite The updated HallPeriodPricing resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsIdPut: async (
      id: string,
      hallPeriodPricingWrite: HallPeriodPricingWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallPeriodPricingsIdPut', 'id', id);
      // verify required parameter 'hallPeriodPricingWrite' is not null or undefined
      assertParamExists(
        'hallPeriodPricingsIdPut',
        'hallPeriodPricingWrite',
        hallPeriodPricingWrite,
      );
      const localVarPath = `/api/hall_period_pricings/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hallPeriodPricingWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of Hall resources.
     * @summary Retrieves the collection of Hall resources.
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [name]
     * @param {boolean} [available]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsGetCollection: async (
      location?: string,
      location2?: Array<string>,
      name?: string,
      available?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/halls`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (location !== undefined) {
        localVarQueryParameter['location'] = location;
      }

      if (location2) {
        localVarQueryParameter['location[]'] = location2;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (available !== undefined) {
        localVarQueryParameter['available'] = available;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a Hall resource.
     * @summary Retrieves a Hall resource.
     * @param {string} id Hall identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsIdGet: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallsIdGet', 'id', id);
      const localVarPath = `/api/halls/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updates the Hall resource.
     * @summary Updates the Hall resource.
     * @param {string} id Hall identifier
     * @param {HallWrite} hallWrite The updated Hall resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsIdPatch: async (
      id: string,
      hallWrite: HallWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallsIdPatch', 'id', id);
      // verify required parameter 'hallWrite' is not null or undefined
      assertParamExists('hallsIdPatch', 'hallWrite', hallWrite);
      const localVarPath = `/api/halls/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/merge-patch+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hallWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the Hall resource.
     * @summary Replaces the Hall resource.
     * @param {string} id Hall identifier
     * @param {HallWrite} hallWrite The updated Hall resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsIdPut: async (
      id: string,
      hallWrite: HallWrite,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('hallsIdPut', 'id', id);
      // verify required parameter 'hallWrite' is not null or undefined
      assertParamExists('hallsIdPut', 'hallWrite', hallWrite);
      const localVarPath = `/api/halls/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/ld+json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hallWrite,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of Hall resources.
     * @summary Retrieve a list of halls available for the given reservation day with the most suitable at the top
     * @param {Time} [startTime] The start time of the hall booking
     * @param {Time} [endTime] The end time of the hall booking
     * @param {string} [date] The end time of the hall booking
     * @param {number} [pax] The pax amount needed for the hall
     * @param {string} [emplacement] The required IRI emplacement of the hall
     * @param {string} [location] The IRI of the location the hall should be selected from
     * @param {string} [reservationDayHall] If a day hall is available the IRI of that day hall can be used to retrieve the suitable halls instead
     * @param {Bool} [available] Whether a hall is available for the booking engine
     * @param {Array<string>} [location2]
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsSuitableGetCollection: async (
      startTime?: Time,
      endTime?: Time,
      date?: string,
      pax?: number,
      emplacement?: string,
      location?: string,
      reservationDayHall?: string,
      available?: Bool,
      location2?: Array<string>,
      name?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/halls_suitable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKey required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (startTime !== undefined) {
        localVarQueryParameter['startTime'] = startTime;
      }

      if (endTime !== undefined) {
        localVarQueryParameter['endTime'] = endTime;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString() : date;
      }

      if (pax !== undefined) {
        localVarQueryParameter['pax'] = pax;
      }

      if (emplacement !== undefined) {
        localVarQueryParameter['emplacement'] = emplacement;
      }

      if (location !== undefined) {
        localVarQueryParameter['location'] = location;
      }

      if (reservationDayHall !== undefined) {
        localVarQueryParameter['reservationDayHall'] = reservationDayHall;
      }

      if (available !== undefined) {
        localVarQueryParameter['available'] = available;
      }

      if (location2) {
        localVarQueryParameter['location[]'] = location2;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HallApi - functional programming interface
 * @export
 */
export const HallApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HallApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of HallEmplacement resources.
     * @summary Retrieve hall emplacements
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [hall]
     * @param {Array<string>} [hall2]
     * @param {string} [emplacement]
     * @param {Array<string>} [emplacement2]
     * @param {string} [hallLocation]
     * @param {Array<string>} [hallLocation2]
     * @param {string} [paxBetween]
     * @param {string} [paxGt]
     * @param {string} [paxGte]
     * @param {string} [paxLt]
     * @param {string} [paxLte]
     * @param {string} [hallSquareMetersBetween]
     * @param {string} [hallSquareMetersGt]
     * @param {string} [hallSquareMetersGte]
     * @param {string} [hallSquareMetersLt]
     * @param {string} [hallSquareMetersLte]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallEmplacementsGetCollection(
      page?: number,
      itemsPerPage?: number,
      hall?: string,
      hall2?: Array<string>,
      emplacement?: string,
      emplacement2?: Array<string>,
      hallLocation?: string,
      hallLocation2?: Array<string>,
      paxBetween?: string,
      paxGt?: string,
      paxGte?: string,
      paxLt?: string,
      paxLte?: string,
      hallSquareMetersBetween?: string,
      hallSquareMetersGt?: string,
      hallSquareMetersGte?: string,
      hallSquareMetersLt?: string,
      hallSquareMetersLte?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallEmplacementsGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallEmplacementsGetCollection(
          page,
          itemsPerPage,
          hall,
          hall2,
          emplacement,
          emplacement2,
          hallLocation,
          hallLocation2,
          paxBetween,
          paxGt,
          paxGte,
          paxLt,
          paxLte,
          hallSquareMetersBetween,
          hallSquareMetersGt,
          hallSquareMetersGte,
          hallSquareMetersLt,
          hallSquareMetersLte,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallEmplacementsGetCollection']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a HallEmplacement resource.
     * @summary Retrieve a single hall emplacement
     * @param {string} id HallEmplacement identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallEmplacementsIdGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallEmplacementRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallEmplacementsIdGet(id, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallEmplacementsIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Updates the HallEmplacement resource.
     * @summary Update an existing hall emplacement
     * @param {string} id HallEmplacement identifier
     * @param {HallEmplacementWrite} hallEmplacementWrite The updated HallEmplacement resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallEmplacementsIdPatch(
      id: string,
      hallEmplacementWrite: HallEmplacementWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallEmplacementRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallEmplacementsIdPatch(
          id,
          hallEmplacementWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallEmplacementsIdPatch']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Replaces the HallEmplacement resource.
     * @summary Replace an existing hall emplacement
     * @param {string} id HallEmplacement identifier
     * @param {HallEmplacementWrite} hallEmplacementWrite The updated HallEmplacement resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallEmplacementsIdPut(
      id: string,
      hallEmplacementWrite: HallEmplacementWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallEmplacementRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallEmplacementsIdPut(
          id,
          hallEmplacementWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallEmplacementsIdPut']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves the collection of HallPeriodPricing resources.
     * @summary Retrieve hall period pricing
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {string} [hall]
     * @param {Array<string>} [hall2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallPeriodPricingsGetCollection(
      page?: number,
      itemsPerPage?: number,
      hall?: string,
      hall2?: Array<string>,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallPeriodPricingsGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallPeriodPricingsGetCollection(
          page,
          itemsPerPage,
          hall,
          hall2,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallPeriodPricingsGetCollection']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a HallPeriodPricing resource.
     * @summary Retrieve a single hall period pricing
     * @param {string} id HallPeriodPricing identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallPeriodPricingsIdGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallPeriodPricingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallPeriodPricingsIdGet(id, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallPeriodPricingsIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Updates the HallPeriodPricing resource.
     * @summary Update an existing hall period pricing
     * @param {string} id HallPeriodPricing identifier
     * @param {HallPeriodPricingWrite} hallPeriodPricingWrite The updated HallPeriodPricing resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallPeriodPricingsIdPatch(
      id: string,
      hallPeriodPricingWrite: HallPeriodPricingWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallPeriodPricingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallPeriodPricingsIdPatch(
          id,
          hallPeriodPricingWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallPeriodPricingsIdPatch']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Replaces the HallPeriodPricing resource.
     * @summary Replace an existing hall period pricing
     * @param {string} id HallPeriodPricing identifier
     * @param {HallPeriodPricingWrite} hallPeriodPricingWrite The updated HallPeriodPricing resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallPeriodPricingsIdPut(
      id: string,
      hallPeriodPricingWrite: HallPeriodPricingWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallPeriodPricingRead>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallPeriodPricingsIdPut(
          id,
          hallPeriodPricingWrite,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallPeriodPricingsIdPut']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves the collection of Hall resources.
     * @summary Retrieves the collection of Hall resources.
     * @param {string} [location]
     * @param {Array<string>} [location2]
     * @param {string} [name]
     * @param {boolean} [available]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallsGetCollection(
      location?: string,
      location2?: Array<string>,
      name?: string,
      available?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallsGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallsGetCollection(
          location,
          location2,
          name,
          available,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallsGetCollection']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves a Hall resource.
     * @summary Retrieves a Hall resource.
     * @param {string} id Hall identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallsIdGet(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HallRead>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.hallsIdGet(
        id,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallsIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Updates the Hall resource.
     * @summary Updates the Hall resource.
     * @param {string} id Hall identifier
     * @param {HallWrite} hallWrite The updated Hall resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallsIdPatch(
      id: string,
      hallWrite: HallWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HallRead>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.hallsIdPatch(
        id,
        hallWrite,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallsIdPatch']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Replaces the Hall resource.
     * @summary Replaces the Hall resource.
     * @param {string} id Hall identifier
     * @param {HallWrite} hallWrite The updated Hall resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallsIdPut(
      id: string,
      hallWrite: HallWrite,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HallRead>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.hallsIdPut(
        id,
        hallWrite,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallsIdPut']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     * Retrieves the collection of Hall resources.
     * @summary Retrieve a list of halls available for the given reservation day with the most suitable at the top
     * @param {Time} [startTime] The start time of the hall booking
     * @param {Time} [endTime] The end time of the hall booking
     * @param {string} [date] The end time of the hall booking
     * @param {number} [pax] The pax amount needed for the hall
     * @param {string} [emplacement] The required IRI emplacement of the hall
     * @param {string} [location] The IRI of the location the hall should be selected from
     * @param {string} [reservationDayHall] If a day hall is available the IRI of that day hall can be used to retrieve the suitable halls instead
     * @param {Bool} [available] Whether a hall is available for the booking engine
     * @param {Array<string>} [location2]
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hallsSuitableGetCollection(
      startTime?: Time,
      endTime?: Time,
      date?: string,
      pax?: number,
      emplacement?: string,
      location?: string,
      reservationDayHall?: string,
      available?: Bool,
      location2?: Array<string>,
      name?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HallsGetCollection200Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hallsSuitableGetCollection(
          startTime,
          endTime,
          date,
          pax,
          emplacement,
          location,
          reservationDayHall,
          available,
          location2,
          name,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['HallApi.hallsSuitableGetCollection']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * HallApi - factory interface
 * @export
 */
export const HallApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = HallApiFp(configuration);
  return {
    /**
     * Retrieves the collection of HallEmplacement resources.
     * @summary Retrieve hall emplacements
     * @param {HallApiHallEmplacementsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsGetCollection(
      requestParameters: HallApiHallEmplacementsGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallEmplacementsGetCollection200Response> {
      return localVarFp
        .hallEmplacementsGetCollection(
          requestParameters.page,
          requestParameters.itemsPerPage,
          requestParameters.hall,
          requestParameters.hall2,
          requestParameters.emplacement,
          requestParameters.emplacement2,
          requestParameters.hallLocation,
          requestParameters.hallLocation2,
          requestParameters.paxBetween,
          requestParameters.paxGt,
          requestParameters.paxGte,
          requestParameters.paxLt,
          requestParameters.paxLte,
          requestParameters.hallSquareMetersBetween,
          requestParameters.hallSquareMetersGt,
          requestParameters.hallSquareMetersGte,
          requestParameters.hallSquareMetersLt,
          requestParameters.hallSquareMetersLte,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a HallEmplacement resource.
     * @summary Retrieve a single hall emplacement
     * @param {HallApiHallEmplacementsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsIdGet(
      requestParameters: HallApiHallEmplacementsIdGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallEmplacementRead> {
      return localVarFp
        .hallEmplacementsIdGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the HallEmplacement resource.
     * @summary Update an existing hall emplacement
     * @param {HallApiHallEmplacementsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsIdPatch(
      requestParameters: HallApiHallEmplacementsIdPatchRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallEmplacementRead> {
      return localVarFp
        .hallEmplacementsIdPatch(
          requestParameters.id,
          requestParameters.hallEmplacementWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the HallEmplacement resource.
     * @summary Replace an existing hall emplacement
     * @param {HallApiHallEmplacementsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallEmplacementsIdPut(
      requestParameters: HallApiHallEmplacementsIdPutRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallEmplacementRead> {
      return localVarFp
        .hallEmplacementsIdPut(
          requestParameters.id,
          requestParameters.hallEmplacementWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of HallPeriodPricing resources.
     * @summary Retrieve hall period pricing
     * @param {HallApiHallPeriodPricingsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsGetCollection(
      requestParameters: HallApiHallPeriodPricingsGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallPeriodPricingsGetCollection200Response> {
      return localVarFp
        .hallPeriodPricingsGetCollection(
          requestParameters.page,
          requestParameters.itemsPerPage,
          requestParameters.hall,
          requestParameters.hall2,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a HallPeriodPricing resource.
     * @summary Retrieve a single hall period pricing
     * @param {HallApiHallPeriodPricingsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsIdGet(
      requestParameters: HallApiHallPeriodPricingsIdGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallPeriodPricingRead> {
      return localVarFp
        .hallPeriodPricingsIdGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the HallPeriodPricing resource.
     * @summary Update an existing hall period pricing
     * @param {HallApiHallPeriodPricingsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsIdPatch(
      requestParameters: HallApiHallPeriodPricingsIdPatchRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallPeriodPricingRead> {
      return localVarFp
        .hallPeriodPricingsIdPatch(
          requestParameters.id,
          requestParameters.hallPeriodPricingWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the HallPeriodPricing resource.
     * @summary Replace an existing hall period pricing
     * @param {HallApiHallPeriodPricingsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallPeriodPricingsIdPut(
      requestParameters: HallApiHallPeriodPricingsIdPutRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallPeriodPricingRead> {
      return localVarFp
        .hallPeriodPricingsIdPut(
          requestParameters.id,
          requestParameters.hallPeriodPricingWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Hall resources.
     * @summary Retrieves the collection of Hall resources.
     * @param {HallApiHallsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsGetCollection(
      requestParameters: HallApiHallsGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallsGetCollection200Response> {
      return localVarFp
        .hallsGetCollection(
          requestParameters.location,
          requestParameters.location2,
          requestParameters.name,
          requestParameters.available,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a Hall resource.
     * @summary Retrieves a Hall resource.
     * @param {HallApiHallsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsIdGet(
      requestParameters: HallApiHallsIdGetRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallRead> {
      return localVarFp
        .hallsIdGet(requestParameters.id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Updates the Hall resource.
     * @summary Updates the Hall resource.
     * @param {HallApiHallsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsIdPatch(
      requestParameters: HallApiHallsIdPatchRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallRead> {
      return localVarFp
        .hallsIdPatch(
          requestParameters.id,
          requestParameters.hallWrite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the Hall resource.
     * @summary Replaces the Hall resource.
     * @param {HallApiHallsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsIdPut(
      requestParameters: HallApiHallsIdPutRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallRead> {
      return localVarFp
        .hallsIdPut(requestParameters.id, requestParameters.hallWrite, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Hall resources.
     * @summary Retrieve a list of halls available for the given reservation day with the most suitable at the top
     * @param {HallApiHallsSuitableGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hallsSuitableGetCollection(
      requestParameters: HallApiHallsSuitableGetCollectionRequest = {},
      options?: AxiosRequestConfig,
    ): AxiosPromise<HallsGetCollection200Response> {
      return localVarFp
        .hallsSuitableGetCollection(
          requestParameters.startTime,
          requestParameters.endTime,
          requestParameters.date,
          requestParameters.pax,
          requestParameters.emplacement,
          requestParameters.location,
          requestParameters.reservationDayHall,
          requestParameters.available,
          requestParameters.location2,
          requestParameters.name,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for hallEmplacementsGetCollection operation in HallApi.
 * @export
 * @interface HallApiHallEmplacementsGetCollectionRequest
 */
export interface HallApiHallEmplacementsGetCollectionRequest {
  /**
   * The collection page number
   * @type {number}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly page?: number;

  /**
   * The number of items per page
   * @type {number}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly itemsPerPage?: number;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hall?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hall2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly emplacement?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly emplacement2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hallLocation?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hallLocation2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly paxBetween?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly paxGt?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly paxGte?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly paxLt?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly paxLte?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hallSquareMetersBetween?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hallSquareMetersGt?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hallSquareMetersGte?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hallSquareMetersLt?: string;

  /**
   *
   * @type {string}
   * @memberof HallApiHallEmplacementsGetCollection
   */
  readonly hallSquareMetersLte?: string;
}

/**
 * Request parameters for hallEmplacementsIdGet operation in HallApi.
 * @export
 * @interface HallApiHallEmplacementsIdGetRequest
 */
export interface HallApiHallEmplacementsIdGetRequest {
  /**
   * HallEmplacement identifier
   * @type {string}
   * @memberof HallApiHallEmplacementsIdGet
   */
  readonly id: string;
}

/**
 * Request parameters for hallEmplacementsIdPatch operation in HallApi.
 * @export
 * @interface HallApiHallEmplacementsIdPatchRequest
 */
export interface HallApiHallEmplacementsIdPatchRequest {
  /**
   * HallEmplacement identifier
   * @type {string}
   * @memberof HallApiHallEmplacementsIdPatch
   */
  readonly id: string;

  /**
   * The updated HallEmplacement resource
   * @type {HallEmplacementWrite}
   * @memberof HallApiHallEmplacementsIdPatch
   */
  readonly hallEmplacementWrite: HallEmplacementWrite;
}

/**
 * Request parameters for hallEmplacementsIdPut operation in HallApi.
 * @export
 * @interface HallApiHallEmplacementsIdPutRequest
 */
export interface HallApiHallEmplacementsIdPutRequest {
  /**
   * HallEmplacement identifier
   * @type {string}
   * @memberof HallApiHallEmplacementsIdPut
   */
  readonly id: string;

  /**
   * The updated HallEmplacement resource
   * @type {HallEmplacementWrite}
   * @memberof HallApiHallEmplacementsIdPut
   */
  readonly hallEmplacementWrite: HallEmplacementWrite;
}

/**
 * Request parameters for hallPeriodPricingsGetCollection operation in HallApi.
 * @export
 * @interface HallApiHallPeriodPricingsGetCollectionRequest
 */
export interface HallApiHallPeriodPricingsGetCollectionRequest {
  /**
   * The collection page number
   * @type {number}
   * @memberof HallApiHallPeriodPricingsGetCollection
   */
  readonly page?: number;

  /**
   * The number of items per page
   * @type {number}
   * @memberof HallApiHallPeriodPricingsGetCollection
   */
  readonly itemsPerPage?: number;

  /**
   *
   * @type {string}
   * @memberof HallApiHallPeriodPricingsGetCollection
   */
  readonly hall?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof HallApiHallPeriodPricingsGetCollection
   */
  readonly hall2?: Array<string>;
}

/**
 * Request parameters for hallPeriodPricingsIdGet operation in HallApi.
 * @export
 * @interface HallApiHallPeriodPricingsIdGetRequest
 */
export interface HallApiHallPeriodPricingsIdGetRequest {
  /**
   * HallPeriodPricing identifier
   * @type {string}
   * @memberof HallApiHallPeriodPricingsIdGet
   */
  readonly id: string;
}

/**
 * Request parameters for hallPeriodPricingsIdPatch operation in HallApi.
 * @export
 * @interface HallApiHallPeriodPricingsIdPatchRequest
 */
export interface HallApiHallPeriodPricingsIdPatchRequest {
  /**
   * HallPeriodPricing identifier
   * @type {string}
   * @memberof HallApiHallPeriodPricingsIdPatch
   */
  readonly id: string;

  /**
   * The updated HallPeriodPricing resource
   * @type {HallPeriodPricingWrite}
   * @memberof HallApiHallPeriodPricingsIdPatch
   */
  readonly hallPeriodPricingWrite: HallPeriodPricingWrite;
}

/**
 * Request parameters for hallPeriodPricingsIdPut operation in HallApi.
 * @export
 * @interface HallApiHallPeriodPricingsIdPutRequest
 */
export interface HallApiHallPeriodPricingsIdPutRequest {
  /**
   * HallPeriodPricing identifier
   * @type {string}
   * @memberof HallApiHallPeriodPricingsIdPut
   */
  readonly id: string;

  /**
   * The updated HallPeriodPricing resource
   * @type {HallPeriodPricingWrite}
   * @memberof HallApiHallPeriodPricingsIdPut
   */
  readonly hallPeriodPricingWrite: HallPeriodPricingWrite;
}

/**
 * Request parameters for hallsGetCollection operation in HallApi.
 * @export
 * @interface HallApiHallsGetCollectionRequest
 */
export interface HallApiHallsGetCollectionRequest {
  /**
   *
   * @type {string}
   * @memberof HallApiHallsGetCollection
   */
  readonly location?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof HallApiHallsGetCollection
   */
  readonly location2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof HallApiHallsGetCollection
   */
  readonly name?: string;

  /**
   *
   * @type {boolean}
   * @memberof HallApiHallsGetCollection
   */
  readonly available?: boolean;
}

/**
 * Request parameters for hallsIdGet operation in HallApi.
 * @export
 * @interface HallApiHallsIdGetRequest
 */
export interface HallApiHallsIdGetRequest {
  /**
   * Hall identifier
   * @type {string}
   * @memberof HallApiHallsIdGet
   */
  readonly id: string;
}

/**
 * Request parameters for hallsIdPatch operation in HallApi.
 * @export
 * @interface HallApiHallsIdPatchRequest
 */
export interface HallApiHallsIdPatchRequest {
  /**
   * Hall identifier
   * @type {string}
   * @memberof HallApiHallsIdPatch
   */
  readonly id: string;

  /**
   * The updated Hall resource
   * @type {HallWrite}
   * @memberof HallApiHallsIdPatch
   */
  readonly hallWrite: HallWrite;
}

/**
 * Request parameters for hallsIdPut operation in HallApi.
 * @export
 * @interface HallApiHallsIdPutRequest
 */
export interface HallApiHallsIdPutRequest {
  /**
   * Hall identifier
   * @type {string}
   * @memberof HallApiHallsIdPut
   */
  readonly id: string;

  /**
   * The updated Hall resource
   * @type {HallWrite}
   * @memberof HallApiHallsIdPut
   */
  readonly hallWrite: HallWrite;
}

/**
 * Request parameters for hallsSuitableGetCollection operation in HallApi.
 * @export
 * @interface HallApiHallsSuitableGetCollectionRequest
 */
export interface HallApiHallsSuitableGetCollectionRequest {
  /**
   * The start time of the hall booking
   * @type {Time}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly startTime?: Time;

  /**
   * The end time of the hall booking
   * @type {Time}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly endTime?: Time;

  /**
   * The end time of the hall booking
   * @type {string}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly date?: string;

  /**
   * The pax amount needed for the hall
   * @type {number}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly pax?: number;

  /**
   * The required IRI emplacement of the hall
   * @type {string}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly emplacement?: string;

  /**
   * The IRI of the location the hall should be selected from
   * @type {string}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly location?: string;

  /**
   * If a day hall is available the IRI of that day hall can be used to retrieve the suitable halls instead
   * @type {string}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly reservationDayHall?: string;

  /**
   * Whether a hall is available for the booking engine
   * @type {Bool}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly available?: Bool;

  /**
   *
   * @type {Array<string>}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly location2?: Array<string>;

  /**
   *
   * @type {string}
   * @memberof HallApiHallsSuitableGetCollection
   */
  readonly name?: string;
}

/**
 * HallApi - object-oriented interface
 * @export
 * @class HallApi
 * @extends {BaseAPI}
 */
export class HallApi extends BaseAPI {
  /**
   * Retrieves the collection of HallEmplacement resources.
   * @summary Retrieve hall emplacements
   * @param {HallApiHallEmplacementsGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallEmplacementsGetCollection(
    requestParameters: HallApiHallEmplacementsGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallEmplacementsGetCollection(
        requestParameters.page,
        requestParameters.itemsPerPage,
        requestParameters.hall,
        requestParameters.hall2,
        requestParameters.emplacement,
        requestParameters.emplacement2,
        requestParameters.hallLocation,
        requestParameters.hallLocation2,
        requestParameters.paxBetween,
        requestParameters.paxGt,
        requestParameters.paxGte,
        requestParameters.paxLt,
        requestParameters.paxLte,
        requestParameters.hallSquareMetersBetween,
        requestParameters.hallSquareMetersGt,
        requestParameters.hallSquareMetersGte,
        requestParameters.hallSquareMetersLt,
        requestParameters.hallSquareMetersLte,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a HallEmplacement resource.
   * @summary Retrieve a single hall emplacement
   * @param {HallApiHallEmplacementsIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallEmplacementsIdGet(
    requestParameters: HallApiHallEmplacementsIdGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallEmplacementsIdGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the HallEmplacement resource.
   * @summary Update an existing hall emplacement
   * @param {HallApiHallEmplacementsIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallEmplacementsIdPatch(
    requestParameters: HallApiHallEmplacementsIdPatchRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallEmplacementsIdPatch(
        requestParameters.id,
        requestParameters.hallEmplacementWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the HallEmplacement resource.
   * @summary Replace an existing hall emplacement
   * @param {HallApiHallEmplacementsIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallEmplacementsIdPut(
    requestParameters: HallApiHallEmplacementsIdPutRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallEmplacementsIdPut(
        requestParameters.id,
        requestParameters.hallEmplacementWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of HallPeriodPricing resources.
   * @summary Retrieve hall period pricing
   * @param {HallApiHallPeriodPricingsGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallPeriodPricingsGetCollection(
    requestParameters: HallApiHallPeriodPricingsGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallPeriodPricingsGetCollection(
        requestParameters.page,
        requestParameters.itemsPerPage,
        requestParameters.hall,
        requestParameters.hall2,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a HallPeriodPricing resource.
   * @summary Retrieve a single hall period pricing
   * @param {HallApiHallPeriodPricingsIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallPeriodPricingsIdGet(
    requestParameters: HallApiHallPeriodPricingsIdGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallPeriodPricingsIdGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the HallPeriodPricing resource.
   * @summary Update an existing hall period pricing
   * @param {HallApiHallPeriodPricingsIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallPeriodPricingsIdPatch(
    requestParameters: HallApiHallPeriodPricingsIdPatchRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallPeriodPricingsIdPatch(
        requestParameters.id,
        requestParameters.hallPeriodPricingWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the HallPeriodPricing resource.
   * @summary Replace an existing hall period pricing
   * @param {HallApiHallPeriodPricingsIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallPeriodPricingsIdPut(
    requestParameters: HallApiHallPeriodPricingsIdPutRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallPeriodPricingsIdPut(
        requestParameters.id,
        requestParameters.hallPeriodPricingWrite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Hall resources.
   * @summary Retrieves the collection of Hall resources.
   * @param {HallApiHallsGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallsGetCollection(
    requestParameters: HallApiHallsGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallsGetCollection(
        requestParameters.location,
        requestParameters.location2,
        requestParameters.name,
        requestParameters.available,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a Hall resource.
   * @summary Retrieves a Hall resource.
   * @param {HallApiHallsIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallsIdGet(
    requestParameters: HallApiHallsIdGetRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallsIdGet(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Updates the Hall resource.
   * @summary Updates the Hall resource.
   * @param {HallApiHallsIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallsIdPatch(
    requestParameters: HallApiHallsIdPatchRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallsIdPatch(requestParameters.id, requestParameters.hallWrite, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the Hall resource.
   * @summary Replaces the Hall resource.
   * @param {HallApiHallsIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallsIdPut(
    requestParameters: HallApiHallsIdPutRequest,
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallsIdPut(requestParameters.id, requestParameters.hallWrite, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Hall resources.
   * @summary Retrieve a list of halls available for the given reservation day with the most suitable at the top
   * @param {HallApiHallsSuitableGetCollectionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HallApi
   */
  public hallsSuitableGetCollection(
    requestParameters: HallApiHallsSuitableGetCollectionRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return HallApiFp(this.configuration)
      .hallsSuitableGetCollection(
        requestParameters.startTime,
        requestParameters.endTime,
        requestParameters.date,
        requestParameters.pax,
        requestParameters.emplacement,
        requestParameters.location,
        requestParameters.reservationDayHall,
        requestParameters.available,
        requestParameters.location2,
        requestParameters.name,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
